// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"3f0604c4","239":"5491b2ce","453":"64aababc","667":"f0b88e3c","821":"a1d8d5b8","977":"9bac61a3"}[chunkId] + ".chunk.js";
};